import { fetchData } from "../../Helpers";

export const STORY_STALE_TIME = 1000 * 60 * 5.5;
export const STORY_CACHE_TIME = Infinity;

export async function getStoryList(
  payload = {
    "limit": 100,
    "offset": 0,
    "archived": false,
    "tutorial": false
  }
) {
  const controller = new AbortController();
  let res = await fetchData({
    endpoint: "/story/list",
    successCallback: () => { },
    payload,
    controller: controller,
  })

  res.stories.sort((a, b) => Number(a?.seen) - Number(b?.seen))
  return res
}


export async function getStoryDescribe(uuid = undefined, storyUUIDsByOrder, initialStoryIndex = false) {
  const controller = new AbortController();
  const INIT_LOAD_COUNT = window.innerWidth < 1020 ? 1 : 2

  if (initialStoryIndex !== false) {
    const backIndex = Math.max(0, initialStoryIndex - INIT_LOAD_COUNT);
    const prevUUIDs = storyUUIDsByOrder.slice(backIndex, initialStoryIndex);
    const nextUUIDs = storyUUIDsByOrder.slice(initialStoryIndex + 1, initialStoryIndex + INIT_LOAD_COUNT + 1)

    const UUIDsToLoad = [...prevUUIDs, storyUUIDsByOrder[initialStoryIndex], ...nextUUIDs]

    const promises = UUIDsToLoad.map(uuid => {
      return fetchData({
        endpoint: "/story/describe",
        successCallback: () => { },
        payload: {
          "group": {
            "uuid": uuid
          }
        },
        controller: controller,
      })
    })

    const result = await Promise.allSettled(promises)
    return result.map(story => story.value)
  }

  const result = await fetchData({
    endpoint: "/story/describe",
    successCallback: () => { },
    payload: {
      "group": {
        "uuid": uuid
      }
    },
    controller: controller,
  })

  return result
}

export function markStoryAsSeen(uuid) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/story/mark-as-seen",
    successCallback: () => { },
    payload: {
      "story": {
        "uuid": uuid
      }
    },
    controller: controller,
  });
}
